import { createElement } from 'react';

const VOID_ELEMENTS = new Set([
  'area',
  'base',
  'br',
  'col',
  'embed',
  'hr',
  'img',
  'input',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr'
]);

const addKey = (acc, value, index) => ({ ...acc, key: `${value}-${index}` });
const isStyleAttribute = (name) => name === 'style';
const addStyleAttribute = (acc, attribute) => {
  const [key, value] = attribute.split(':').map((s) => s.trim());
  return { ...acc, [key]: value };
};
const getStyleAttributeObject = (styleAttributeValue) =>
  styleAttributeValue
    .split(';')
    .map((s) => s.trim())
    .reduce(addStyleAttribute, {});
const addAttribute = (acc, { name, value }) => {
  return {
    ...acc,
    [name]: isStyleAttribute(name) ? getStyleAttributeObject(value) : value || true
  };
};
const getChildNodesArray = (childNodes, mappingFunction) =>
  Array.from(childNodes).map(mappingFunction);
const getProps = (acc, attributes) => {
  return attributes.reduce((acc, attribute) => addAttribute(acc, attribute), acc);
};
const isTextNode = ({ localName }) => !localName;
const getHTMLElement = ({ attributes, localName: type, childNodes }, index) => {
  const props = getProps(addKey({}, type, index), Array.from(attributes));
  const children = VOID_ELEMENTS.has(type) ? [] : getChildNodesArray(childNodes, mapNodeToElement);

  return createElement(type, props, ...children);
};
const getNodeValue = ({ nodeValue }) => nodeValue;
const mapNodeToElement = (node, index) =>
  isTextNode(node) ? getNodeValue(node) : getHTMLElement(node, index);
const getChildNodes = (str) => {
  return new DOMParser().parseFromString(str, 'text/html').body.childNodes;
};

export const StringToJSX = ({ domString }) => {
  return Array.from(getChildNodes(domString)).map(mapNodeToElement);
};
